export default __webpack_public_path__ + "static/media/AdBlue_canwithoutnozzle.5a420433.svg";